import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const DocumentsGridWrapper = styled<any, any>(
    'div',
    'documentsGridWrapper',
    'documentsGrid'
)`
    ${propStyles};
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
`;

DocumentsGridWrapper.defaultProps = {};

export default DocumentsGridWrapper;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentsGridWrapper.tsx